
        import '/home/builduser/work/c1dd1064fea009a6/santa-editor/packages/sections/bootstrap/plugins/core/attachLabelPlugin.scss.css.virtualfile';
        module.exports = {"container":"_container_nifuj_1","name":"_name_nifuj_7"};